module.exports = __webpack_public_path__ + "static/media/background-4.7eb9729b.jpg";